<template>
  <div v-if="visible" class="pdm_overlay" @click.self="$emit('close')">
    <div class="pdm_modal" role="dialog" aria-modal="true">
      <div class="pdm_icon"><i class="mdi mdi-alert-circle-outline"></i></div>
      <h3 class="pdm_title">Payment failed</h3>
      <p class="pdm_text">
        Your last subscription payment didn't go through. To keep access to the
        platform, please update your payment method now.
      </p>
      <p v-if="!isResponsable" class="pdm_note">
        Please contact your account administrator to update the payment method.
      </p>
      <div class="pdm_actions">
        <button type="button" class="back-btn" @click="$emit('close')">Later</button>
        <button
          v-if="isResponsable"
          type="button"
          class="primary-action-button"
          :disabled="loading"
          @click="openPortal"
        >
          {{ loading ? 'Opening…' : 'Update payment method' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue-sonner'
import api from '../../tools/api'

export default {
  name: 'PastDueModal',
  props: {
    visible: { type: Boolean, default: false },
  },
  emits: ['close'],
  data() {
    return { loading: false }
  },
  computed: {
    // Only the account owner (Responsable) manages billing → portal access.
    isResponsable() {
      return this.$store.state.role === 'Responsable'
    },
  },
  methods: {
    // Open the Stripe Customer Portal so the user can update their card.
    async openPortal() {
      this.loading = true
      try {
        const { data } = await api.post(process.env.VUE_APP_API_URL + '/restrict/stripe/portal')
        if (data && data.url) {
          window.location.href = data.url
        } else {
          toast.error('Unable to open the payment portal')
        }
      } catch (e) {
        console.error('Error opening portal:', e)
        toast.error('Impossible d\'ouvrir le portail de paiement')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.pdm_overlay {
  position: fixed;
  inset: 0;
  background: rgba(19, 57, 103, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 3000;
}
.pdm_modal {
  background: #FFFFFF;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-modal);
  width: 100%;
  max-width: 440px;
  padding: 32px;
  text-align: center;
}
.pdm_icon {
  font-size: 48px;
  line-height: 1;
  color: var(--color-status-error);
  margin-bottom: 12px;
}
.pdm_title {
  font-family: var(--font-title);
  font-weight: 500;
  font-size: var(--font-size-section);
  color: var(--color-dark-blue);
  margin: 0 0 12px;
}
.pdm_text {
  font-family: var(--font-body);
  font-size: var(--font-size-body);
  line-height: 1.5;
  color: var(--color-dark-blue);
  margin: 0 0 24px;
}
.pdm_note {
  font-family: var(--font-body);
  font-size: var(--font-size-small);
  line-height: 1.5;
  color: var(--color-text-muted);
  margin: -12px 0 24px;
}
.pdm_actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
</style>
